import { importWithRetry } from '@/utils/component-loader'
import { defineAsyncComponent } from 'vue'

const sharedComponentMapping = {
  embedded_iframe_modal: () => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "embedded-iframe-modal" */ '../shared/embedded-iframe-modal')),
  redirect: () => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "daisy-chain-redirect" */ '../shared/redirect')),
  welcome_modal: () => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "welcome-modal" */ '../shared/welcome-modal'))
}
const componentMapping = {
  event: {
    ...sharedComponentMapping,
    local_chapter_modal: () => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "petition-local-chapter-modal" */ '@/daisy-chains/events/local-chapter-modal')),
    registration_modal: () => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "event-registration-modal" */ '../events/registration-modal')),
    share_modal: () => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "event-share-modal" */ '../events/share-modal')),
    welcome_to_local_chapter_modal: () => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "event-welcome-modal" */ '../events/welcome-to-local-chapter-modal'))
  },
  petition: {
    ...sharedComponentMapping,
    effort_modal: () => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "petition-effort-modal" */ '../petitions/effort-modal')),
    event_modal: () => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "petition-event-modal" */ '../petitions/event-modal')),
    local_chapter_modal: () => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "petition-local-chapter-modal" */ '../petitions/local-chapter-modal')),
    promoted_petition_modal: () => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "promoted-petition-modal" */ '../petitions/promoted-petition-modal')),
    share_modal: () => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "petition-share-modal" */ '../petitions/share-modal'))
  }
}

const trackingMetadataByPageAndStepKind = {
  event: {
    embedded_iframe_modal: {
      name: 'Saw IFrame Modal Step',
      slug: 'iframe-modal'
    },
    local_chapter_modal: {
      name: 'Saw Local Chapter Modal Step',
      slug: 'local-chapter-modal'
    },
    redirect: {
      name: 'Redirect After Event RSVP',
      slug: 'redirect'
    },
    registration_modal: {
      name: 'Saw Registration Modal Step',
      slug: 'registration-modal'
    },
    share_modal: {
      name: 'Saw Share Modal Step',
      slug: 'share-modal'
    },
    welcome_modal: {
      name: 'Saw Welcome Modal Step',
      slug: 'welcome-modal'
    },
    welcome_to_local_chapter_modal: {
      name: 'Saw Welcome To Local Group Modal Step',
      slug: 'welcome-to-local-group'
    }
  },
  petition: {
    effort_modal: {
      name: 'Saw Effort Modal Step',
      slug: 'effort-modal'
    },
    embedded_iframe_modal: {
      name: 'Saw IFrame Modal Step',
      slug: 'iframe-modal'
    },
    event_modal: {
      name: 'Saw Event Modal Step',
      slug: 'event-modal'
    },
    local_chapter_modal: {
      name: 'Saw Local Chapter Modal Step',
      slug: 'local-chapter-modal'
    },
    promoted_petition_modal: {
      name: 'Saw Promoted Petition Modal Step',
      slug: 'promoted-petition-modal'
    },
    redirect: {
      name: 'Redirect After Signing Petition',
      slug: 'redirect'
    },
    share_modal: {
      name: 'Saw Share Modal Step',
      slug: 'share-modal'
    },
    welcome_modal: {
      name: 'Saw Welcome Modal Step',
      slug: 'welcome-modal'
    }
  }
}

export default {
  currentStepComponent: (state) => {
    return defineAsyncComponent(componentMapping[state.pageKind][state.currentStepKind])
  },

  firstStepUrl: (state) => {
    return `${state.baseUrl}/start`
  },

  nextStepUrl: (state) => {
    return `${state.baseUrl}/${state.previousStepKind}`
  },

  trackingEventDataForCurrentStep: (state) => {
    const page = state.stepTrackingData.page
    const action = state.stepTrackingData.action

    const trackingData = {
      action: trackingMetadataByPageAndStepKind[state.pageKind][state.currentStepKind].slug,
      category: `${state.pageKind}-daisy-chain`,
      name: page.slug,
      source: action.source,
      value: action.source
    }

    trackingData[state.pageKind] = page.slug

    // Certain steps have extra tracking data
    switch (state.currentStepKind) {
    case 'promoted_petition_modal':
      trackingData.promoted_petition = state.stepData.promotedPetitions[0].slug
      trackingData.value = state.stepData.promotedPetitions[0].slug
      break
    case 'redirect':
      trackingData.redirect_url = state.stepData.redirectUrl
      trackingData.value = state.stepData.redirectUrl
      break
    }

    return trackingData
  },

  trackingEventNameForCurrentStep: (state) => {
    return trackingMetadataByPageAndStepKind[state.pageKind][state.currentStepKind].name
  },

  trackingIdentity: (state) => {
    const memberInfo = state.stepTrackingData.member
    // TODO: include anonymousId in here either way, as we do in views/tracking_integrations/_track_action.erb
    return memberInfo ? { id: memberInfo.id, email: memberInfo.email } : {}
  }
}
